<template>
    <div class="grid grid-cols-[65%_35%] gap-2 items-center text-xs mb-3">
        <div class="flex gap-1.5 items-center">
            <div
                class="dot"
                :style="`background-color: ${color}`"
            />
            <div>
                {{ label }}
            </div>
        </div>
        <div
            class="font-medium"
            :style="`color: ${color}`"
        >
            {{ value }}
        </div>
    </div>
</template>
<script setup lang="ts">
const props = defineProps<{
    color: string
    label: string
    value: string | number
}>()


</script>



<style scoped lang="scss">
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

</style>
